import { GeoJsonObject } from 'geojson'
import { createStore } from 'zustand'
import { immer } from 'zustand/middleware/immer'

interface DemandAnalysisState {
  perimeter: {
    edited?: boolean
    done?: boolean
    shapefile: File[]
    zip: Blob
    results: {
      filename: string
      area: number
      centroid: [number, number]
      geojson: GeoJsonObject
    }
  } | null
  mosaic: {
    done?: boolean
    input: File
    results: {
      gsd: number
      coord_x: number
      coord_y: number
      px_res: number
    }
  } | null
}

interface DemandAnalysisActions {
  setPerimeter: (perimeter: DemandAnalysisState['perimeter']) => void
  setMosaic: (mosaic: DemandAnalysisState['mosaic']) => void
  markFileAsDone: (fileType: 'perimeter' | 'mosaic') => void

  reset: () => void
  resetPerimeter: () => void
}

export type DemandAnalysisStoreData = DemandAnalysisState &
  DemandAnalysisActions

export type DemandAnalysisStore = ReturnType<typeof createDemandAnalysisStore>

export function createDemandAnalysisStore() {
  return createStore<DemandAnalysisStoreData>()(
    immer((set) => ({
      perimeter: null,
      mosaic: null,

      setPerimeter: (perimeter) => set({ perimeter: perimeter }),
      setMosaic: (mosaic) => set({ mosaic: mosaic }),
      markFileAsDone: (fileType) =>
        set((state) => {
          const currentFile = state[fileType]
          if (currentFile) {
            currentFile.done = true
          }
        }),

      reset: () =>
        set({
          perimeter: null,
          mosaic: null,
        }),
      resetPerimeter: () => set({ perimeter: null }),
    })),
  )
}
